import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class PackageSubscriptionService {

  constructor(
    private httpClient: HttpClient
  ) { }

  getSubPackagelist(filter: any) {
    return this.httpClient.get(`ReportSubscriptionPackages/getList`, {
      params: filter
    });
  }
  
  getSubPackageDetailsById(reportSubscriptionPackageId) {
    return this.httpClient.get(`ReportSubscriptionPackages/package-details/?reportSubscriptionPackageId=${reportSubscriptionPackageId}`, {
    });
  }
  subPackagePurchase(data) {
    return this.httpClient.post(`ReportSubscriptionPackages/package-purchase-payment-type`,  data);
  }
  getPaidPackageTokenDetails(reportSubscriptionPackageId) {
    return this.httpClient.get(`ReportSubscriptionPackages/package-price?reportSubscriptionPackageId=${reportSubscriptionPackageId}`);
  }
  purchasePackage(reportSubscriptionPackageId) {
    return this.httpClient.post(`ReportSubscriptionPackages/purchase-package?reportSubscriptionPackageId=${reportSubscriptionPackageId}`, {})
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/services/package-subscription.service.ts